export default "__VITE_ASSET__CU$Tvu12__"